import tracking from 'dibs-tracking';

export function trackBreadcrumbClick(key) {
    tracking.trackEvent({
        category: 'navigation',
        action: 'breadcrumb click',
        label: `pdp|${key}`,
    });
}
